<template>
    <slot data-bs-toggle="modal" :data-bs-target="'#BuySub' + TbtnId" :click="openModal"></slot>
        <div class="modal fade" tabindex="-1" :id="'BuySub' + TbtnId" data-bs-backdrop="false" >
          <div class="modal-dialog modal-xl" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">2025 Summer Camp 신청하기</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" style="padding:40px;">
                <td colspan="3" style="text-align:left; ">
              <!--span style="font-weight: bold; color: red; font-size : 18pt">- 개별신청이 아닌 LMS에서 신청하면 나라 선택이 미국으로만 가능합니다.</span-->
            </td>
                <table class="table" >
                  <tbody>
                    <tr>

                      <td colspan="3" style="text-align:left; ">
                        
<query-grid :config="config" ref="lqg" v-if="!hide_order_studentName">
<template #items="props">
<tr v-for="record in props.records" v-bind:key="record.id" :class="{'table-danger': record.is_deleted}" >
<td scope="col">
  <input type="checkbox" v-model="record.checked" @click="is_extend = false;" v-if="record.success !== '1'">
  <template v-else>
    <span style="background:#e53953; color:#fff; padding:4px 10px; font-size:12px; border-radius:10px; ">신청완료</span>
  </template>
</td>
<td scope="row" style="text-align:center;">{{ record.id }}</td>
<td style="text-align:center;">
<Business v-if="record.t2" :biz="record.t2" /></td>
<td  style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" />

</td>
<td style="text-align:center;"><!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
@click="moreStudentInfo(record)">{{ record.username }}</a-->
{{ record.username }}
</td>
<td style="text-align:center;">
<Student :student="record" />
</td>
<td style="text-align:center;"><span v-if="record.type === 'MYPATH'">MY PATH</span>
<span v-if="record.type === 'MYUSE'">MY USE</span>
</td>
<td style="text-align:center;">{{ record.level }}</td>
<td style="text-align:center;"><span v-if="record.startDate">{{ record.startDate.substr(2, 8) }}</span></td>
<td style="text-align:center;"><span v-if="record.endDate">{{ record.endDate.substr(2, 8) }}</span></td>
<td style="text-align:center;"><span v-if="record.endDate"  :style="{'color': getDiff(record.endDate) <= 0 ? 'red': ''}">{{ getDiff(record.endDate) + ' 일' }}</span></td>

<td style="text-align:center;"><span v-if="!record.active_subscription_id" style="background:#ff0000;color:#fff;padding:2px 6px; font-size:12px;">미사용</span><template v-else><span
v-if="record.ranking_exception" style="background:#ffcc00;color:#333; padding:2px 6px; font-size:12px;">이벤트</span><span v-else style="background:#0071e3;color:#fff; padding:2px 6px; font-size:12px;">정회원</span></template></td>

</tr>
</template>
</query-grid>

        </td>
                      <!-- 회원정보에서 상품구매시 해당 회원정보 가지고 올 것 -->
                      <!--<strong>학생명</strong>
  -->


                    </tr>

                  </tbody>
                </table>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                    v-on:click="createEvent()" @click="$parent.$parent.$refs.qg.search()">2025 Summer Camp 신청하기</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>

              </div>
            </div>
          </div>
        </div>
</template>

<script>

import Business from "../Business.vue"
  import Student from "../detail_pages/Student.vue"
  import Subscription from "../detail_pages/Subscription.vue"
  import QueryGrid from "../QueryGrid"
  import axios from "axios";


export default {
        name: 'CreateSubscription',
    props: {
        student: Object,
        subscription: Object,
        btnId: String
    },
    components: {
        Business,
        Student,
        Subscription,
        QueryGrid
    },
    mounted(){
      this.$refs.lqg.search();


    },

    methods: {

        openModal(is_modal_opened){
            if(!is_modal_opened){
                        this.$nextTick(function(){
          var modalDom = document.getElementById("BuySub" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs.modal', function (event) {
            this.active = false;
          })
          modal.show();
        });


            }

            this.$refs.lqg.search();
        },
      fetchProducts(source) {
        var extras="?";
        if(source){
          extras += "source=" + source.id
        }
        axios.get('/products' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }


        })
      },
            getDiff(value) {

        var moment = require('moment'); // moment 모듈불러오기

        const diff = moment().diff(value, 'hours');
        const days = Math.floor(diff / 24);
        const hours = diff % 24;

        return -days;

      },
      createEvent() {
        var base = this.$refs.lqg ? this.$refs.lqg.checked : []
        if(this.hide_order_studentName){
          base = [this.student]
        }
          base.forEach((s) => {


        axios.post('/students/eventAdd/summer2025', {
          'student': s.id
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: s.name + ' Event 신청 실패: ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.$refs.lqg.search();
            $.notify({
              // options
              message: s.name + ' 신청되었습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }


        })


          }

          );

      },
            fetchSubscriptionsOfStudent(student) {
        var extras = "";
        console.log(student)
        axios.get('/subscriptions?student=' + student.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.ext_subscriptions = response.data.result;
            this.addData.subscription = this.ext_subscriptions[0]
            this.fetchProducts(this.addData.subscription);
          }


        })
      },
      chgExtend(){
        if(!this.is_extend){
          this.fetchProducts();
        } else {
            this.fetchSubscriptionsOfStudent(this.$refs.lqg.checked[0])
        }
      },
      extendForm(){
        this.is_extend = true;
        this.selStudent = {id: this.selSub.studentId};
        this.addData.subscription = this.selSub;
        this.fetchProducts(this.selSub);
        this.fetchSubscriptionsOfStudent(this.selStudent)
        this.hide_order_studentName= true
        this.hide_order_previousSub= true
      },
      resetForm(){
          if(this.subscription || this.student) return;
        this.is_extend = false;
        this.selStudent = {};
        this.hide_order_studentName= false
        this.hide_order_previousSub= false
        this.fetchProducts();
      },
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
                    selSub: {

        },
        students: [],
        selStudent: {},
        payMethod: "",
        selProduct: {},
        products: {},
        is_extend: false,

        addData: {

        },
        hide_order_studentName: false,
        hide_order_previousSub: false,
                config: {
    "name": "학생 리스트",
    "req_endpoint": "/students/event/summer2025",
    "default_limit": 20,
    "no_excel": true,
    "search_fields": [
        {
            "id": "businesses",
            "name": "소속선택",
            "type": "business" // business, date, datetime,
        },
    ],
    "columns": [
              {
            "id": "chkbox",
            "name": "체크",
        },
        {
            "id": "id",
            "sortable": true,
            "name": "회원번호",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "biz",
            "name": "학원",
            "excel_print": v=>{return v.t2.name}
        },
                {
            "id": "class",
            "name": "클래스",
            "excel_print": v=>{return v.t1.name}
        },
        {
            "id": "username",
            "sortable": true,
            "name": "아이디",
            "excel_print": v=>{return v.username}
        },
        {
            "id": "hanname",
            "sortable": true,
            "name": "이름",
            "excel_print": v=>{return v.name}
        },

        {
            "id": "type",
            "sortable": true,
            "name": "유형",
            "excel_print": v=>{return v.type || ''}
        },
        {
            "id": "level",
            "sortable": true,
            "name": "레벨",
            "excel_print": v=>{return v.level || ''}
        },
        {
            "id": "start_date",
            "sortable": true,
            "name": "시작일",
            "excel_print": v=>{return v.startDate || ''}
        },
        {
            "id": "end_date",
            "sortable": true,
            "name": "종료일",
            "excel_print": v=>{return v.endDate || ''}
        },
        {
            "id": "remain_days",
            "sortable": true,
            "name": "잔여일",
            "excel_print": v=>{return this.getDiff(v.endDate) || ''}
        },
        {
            "id": "status",
            "name": "상태",
            "excel_print": v=>{return (v.active_subscription_id ? (v.ranking_exception ? '이벤트' : '정회원') : '미사용')}
        }
    ]
}
        }
    }
}
</script>

<style>

</style>
